export default "__VITE_ASSET__CYt390yz__"